export const INTERCEPT_AUTH = 'INTERCEPT_AUTH';
export const INTERCEPT_CREDICORP_AUTH = 'INTERCEPT_CREDICORP_AUTH';
export const INTERCEPT_PREFIX = 'INTERCEPT_PREFIX';
export const INTERCEPT_ALTERNATIVE_PREFIX = 'INTERCEPT_ALTERNATIVE_PREFIX';